module.exports = __webpack_public_path__ + "static/media/nextuLogo.829ad0a1.webp";